import intercom from '../Utils/Intercom'

export default ({ redirect, store, context, app }, inject) => {
    intercom.boot(store.$auth.user, app?.i18n?.locale ?? 'ar')
}
